import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './MalyalamFest.scss';

const malyalamFestivals = [
  {
    id: 1,
    name: 'Onam',
    img: 'https://blog.milkbasket.com/wp-content/uploads/2022/08/3-8.jpg',
    desc: 'Onam is the biggest festival in Kerala, celebrating the annual homecoming of the legendary King Mahabali. It is marked by flower decorations, boat races, dances, and the grand Onasadya feast.'
  },
  {
    id: 2,
    name: 'Vishu',
    img: 'https://images.news18.com/ibnlive/uploads/2025/04/vishu-kerala-new-year-2025-date-history-2025-04-2e6053dcb8f86cc95e88664595eaaf8a.jpg?impolicy=website&width=0&height=0',
    desc: 'Vishu marks the Malayali New Year and is celebrated with "Vishukkani" (auspicious viewing), firecrackers, and feasting. Elders give money (Vishukkaineetam) to the younger members.'
  },
  {
    id: 3,
    name: 'Thrissur Pooram',
    img: 'https://i.pinimg.com/736x/4d/b8/26/4db826d4587c82d6813b8dbd33dfe149.jpg',
    desc: 'Thrissur Pooram is a vibrant temple festival known for its magnificent elephant procession, percussion performances, and grand fireworks at Vadakkunnathan Temple.'
  },
  {
    id: 4,
    name: 'Makaravilakku',
    img: 'https://www.poojn.in/wp-content/uploads/2025/06/Makaravilakku-and-Ayyappan-The-Sacred-Ritual-Explained-2025-Guide.jpeg.jpg',
    desc: 'Makaravilakku is celebrated at Sabarimala temple in honor of Lord Ayyappa. A celestial light appears on the horizon as devotees gather for rituals and prayers.'
  },
  {
    id: 5,
    name: 'Attukal Pongala',
    img: 'https://compass.rauias.com/wp-content/uploads/2024/02/image-123.png',
    desc: 'Attukal Pongala is a unique festival where millions of women gather to offer Pongala (a sweet dish) to the goddess Attukalamma in Thiruvananthapuram.'
  },
  {
    id: 6,
    name: 'Karthika Deepam',
    img: 'https://i.pinimg.com/236x/8e/bc/cb/8ebccb96bebf27515480381c1a1959a3.jpg',
    desc: 'Celebrated with lighting of oil lamps in homes and temples, Karthika Deepam is associated with the worship of Lord Shiva and Subrahmanya.'
  },
  {
    id: 7,
    name: 'Navaratri',
    img: 'https://thumbs.dreamstime.com/b/couple-playing-garba-dandiya-night-navratri-dussehra-festival-vector-design-77726145.jpg',
    desc: 'In Kerala, Navaratri is celebrated by worshipping Saraswati Devi and includes placing books before the deity for blessings and educational prosperity.'
  },
  {
    id: 8,
    name: 'Thaipooyam',
    img: 'https://static.vecteezy.com/system/resources/previews/015/697/606/non_2x/happy-thaipusam-festival-concept-free-vector.jpg',
    desc: 'Thaipooyam is celebrated in honor of Lord Murugan with kavadi attam (devotional dance) and processions, especially in temples like Koorkancherry and Haripad.'
  },
  {
    id: 9,
    name: 'Adoor Gajamela',
    img: 'https://www.poojn.in/wp-content/uploads/2025/06/Kerala-Temple-Festivals-2025-A-Guide-to-the-Celebrations.jpeg.jpg',
    desc: 'Held at Parthasarathy temple in Adoor, this festival features a majestic elephant parade, music, and rituals attracting thousands of devotees.'
  },
  {
    id: 10,
    name: 'Chettikulangara Bharani',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyH8Bqz3tqLMZ-JTV_g2o_ph1aMtcvRtFXAg&s',
    desc: 'Celebrated at Chettikulangara Bhagavathy Temple, it features colorful Kuthiyottam and Kettukazhcha processions that showcase massive decorated structures.'
  },
];

const MalyalamFest = () => {
  const [selectedFest, setSelectedFest] = useState(null);

  const openPopup = (fest) => {
    setSelectedFest(fest);
  };

  const closePopup = () => {
    setSelectedFest(null);
  };

  return (
    <div className="malyalamfest-container">
      <InnerNav />
      <div className="malyalamfest-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Popular Malayalam Festivals</h4>
        </div>

        <div className="festival-grid">
          {malyalamFestivals.map((fest) => (
            <div className="festival-card" key={fest.id} onClick={() => openPopup(fest)}>
              <img
              src={fest.img || 'https://blogs.revv.co.in/blogs/wp-content/uploads/2020/11/Theyyam-Festival.jpeg'}
                alt={fest.name}
              />
              <p>{fest.name}</p>
            </div>
          ))}
        </div>

        {selectedFest && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedFest.name}</h3>
              <img
              src={selectedFest.img || 'https://blogs.revv.co.in/blogs/wp-content/uploads/2020/11/Theyyam-Festival.jpeg'}
                alt={selectedFest.name}
              />
              <p>{selectedFest.desc}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default MalyalamFest;
